import styled from 'styled-components';

import Button from 'components/Button';

export const SRow = styled.div`
  align-items: flex-end;
  display: flex;
  margin-bottom: 15px;

  .form__group {
    flex: 1;
    margin-bottom: 0;
  }
`;

export const SAddUtteranceButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 20px;
  width: 75px;
  display: flex;
  align-items: center;

  &&& {
    min-width: unset;
    padding: 6px 17px;
  }
`;

export const STriagle = styled.span`
  .triangle {
    border-bottom: 5px solid transparent;
    border-left: 5px solid #ffffff;
    border-top: 5px solid transparent;
    content: '';
    display: inline-block;
    height: 0;
    margin-right: 10px;
    width: 0;
  }
`;

export const SPlusIcon = styled.span`
  margin-right: 8px;
  font-size: 20px;
`;
